<template>
  <div class="container">
    <a-card title="编辑资料" headStyle="background:#f3f3f3">
      <a-form
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :rules="rules"
        :model="formState"
        ref="formRef"
      >
        <a-form-item label="供应商" name="name">
          <a-input
            placeholder="请输入供应商名称"
            v-model:value="formState.name"
          ></a-input>
          <!-- <a-select>
            <a-select-option
              v-for="(item, index) in supplyName"
              :key="index"
              :value="index"
            >
              {{ item }}
            </a-select-option>
          </a-select> -->
        </a-form-item>
        <a-form-item label="供应角色" name="labelInValue">
          <a-select v-model:value="labelInValue">
            <a-select-option
              v-for="(item, index) in rolesList"
              :key="index"
              :value="item.id"
              :label="item.name"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="账号:" name="username">
          <a-input v-model:value="formState.username" @blur="onlyUser()" />
        </a-form-item>
        <a-form-item label="默认密码:">
          <a-input
            value="888888"
            :type="inputType"
            v-model:value="formState.password"
          >
            <template #suffix>
              <EyeInvisibleOutlined
                v-model:value="isEyes"
                v-if="!isEyes"
                @click="
                  isEyes = true;
                  inputType = 'text';
                "
              />
              <EyeOutlined
                v-model:value="isEyes"
                v-else
                @click="
                  isEyes = false;
                  inputType = 'password';
                "
              />
            </template>
          </a-input>
        </a-form-item>
        <a-form-item label="手机号码:" name="contactPhone">
          <a-input v-model:value="formState.contactPhone" />
        </a-form-item>
        <a-form-item label="会员等级:" name="supplierLevel">
          <a-select v-model:value="formState.supplierLevel">
            <a-select-option v-for="(item, index) in levelList" :key="index">{{
              item.label
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="公司简称:" name="shortName">
          <a-input v-model:value="formState.shortName" />
        </a-form-item>
        <!-- <a-form-item label="公司:">
          <a-input />
        </a-form-item> -->
        <a-form-item label="扣点设置:">
          <a-select v-model:value="formState.points">
            <a-select-option v-for="(item, index) in set" :key="index">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="联系人姓名:" name="companyContact">
          <a-input v-model:value="formState.companyContact" />
        </a-form-item>
        <a-form-item label="业务类型:" name="checked">
          <a-checkbox v-model:checked="checked">国内</a-checkbox>
          <a-checkbox v-model:checked="checked1">国外</a-checkbox>
        </a-form-item>
        <a-form-item label="用途:" name="purpose">
          <a-checkbox-group v-model:value="formState.purpose">
            <a-checkbox
              v-for="(item, index) in useList"
              :key="index"
              :value="index"
              >{{ item }}</a-checkbox
            >
          </a-checkbox-group>
        </a-form-item>
        <a-form-item label="业务权限" name="premission">
          <a-checkbox-group
            v-model:value="formState.premission"
            style="width: 100vw"
          >
            <a-checkbox
              v-for="(item, index) in staticSupply.business"
              :key="index"
              :value="index"
            >
              {{ item }}
            </a-checkbox>
          </a-checkbox-group>
        </a-form-item>
        <a-form-item label="收款方式:" name="payment">
          <a-checkbox-group v-model:value="formState.payment">
            <a-checkbox
              v-for="(item, index) in payTypeList"
              :key="index"
              :value="index"
              >{{ item }}</a-checkbox
            >
          </a-checkbox-group>
        </a-form-item>
        <a-form-item label="合作期限" name="joinTime">
          <a-range-picker
            v-model:value="joinTime"
            valueFormat="YYYY-MM-DD"
            format="YYYY-MM-DD"
          ></a-range-picker>
        </a-form-item>
        <a-form-item label="城市">
          <a-cascader
            v-model:value="formState.companyCity"
            :options="cityOptions"
            placeholder="选择城市"
            :show-search="{ filter }"
          />
        </a-form-item>
        <a-form-item label="用户来源:">
          <a-select v-model:value="formState.userSource">
            <a-select-option
              v-for="(item, index) in sourceList"
              :key="index"
              :value="index"
              >{{ item }}</a-select-option
            >
          </a-select>
          <!-- <a-input style="width: 222.5" v-model:value="formState.userSource" /> -->
        </a-form-item>
        <a-form-item label="营业执照">
          <a-upload
            v-model:file-list="fileList"
            name="businessLicense"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            action="http://yapi.tianxiapiao.cn/mock/11/v1/manager/b2b/supplier/insert"
            :before-upload="beforeUpload"
            @change="handleChange"
          >
            <img
              v-if="imageUrl"
              :src="imageUrl"
              alt="avatar"
              style="max-width: 102px"
            />
            <div v-else>
              <loading-outlined v-if="loading"></loading-outlined>
              <plus-outlined v-else></plus-outlined>
              <div class="ant-upload-text">上传图片</div>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item label="上传协议" style="width: 100%">
          <a-upload
            v-model:file-list1="fileList1"
            name="agreement"
            :multiple="true"
            action="http://yapi.tianxiapiao.cn/mock/11/v1/manager/b2b/supplier/insert"
            :before-upload="beforeUpload"
          >
            <span class="uploadStyle">
              <CloudUploadOutlined />
              选择上传文件
            </span>
          </a-upload>
          <span style="font-size: 12px"
            >只能上传jpg/png格式文件,文件不能超过50kb</span
          >
        </a-form-item>
        <a-form-item label="备注">
          <textarea
            v-model="formState.remark"
            name="remark"
            style="width: 100%"
          >
          </textarea>
        </a-form-item>
        <a-form-item label="账户开启状态">
          <a-switch v-model:checked="state" />
        </a-form-item>
        <a-row>
          <a-col :offset="8">
            <a-button @click="addSupplyer">提交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </a-card>
  </div>
</template>

<script>
import {
  reactive,
  ref,
  computed,
  watch,
  toRaw,
  onMounted,
  nextTick,
} from "vue";
import cityOptions from "../../lib/city";
import staticSupply from "@/assets/supply";
import menu from "@axios/sysmenu";
import {
  PlusOutlined,
  LoadingOutlined,
  CloudUploadOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
} from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import supply from "@/axios/supply";
import { useRoute, useRouter } from "vue-router";
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default {
  name: "addSupply",
  components: {
    LoadingOutlined,
    PlusOutlined,
    CloudUploadOutlined,
    EyeOutlined,
    EyeInvisibleOutlined,
  },
  setup() {
    let route = useRoute();
    let router = useRouter();
    //供应角色
    let labelInValue = ref("");
    //验证
    const formRef = ref();
    //合作期限
    let joinTime = ref([]);
    let inputType = ref("password");
    //small eyes
    let isEyes = ref(false);
    //国内内外
    let checked = ref(false);
    let checked1 = ref(false);
    const fileList = ref([]);
    const fileList1 = ref([]);
    const loading = ref(false);
    const imageUrl = ref("");
    let levelList = reactive([
      {
        label: "普通会员",
        value: 0,
      },
      {
        label: "黄金会员",
        value: 1,
      },
      {
        label: "白金会员",
        value: 2,
      },
      {
        label: "钻石会员",
        value: 3,
      },
    ]);
    let set = reactive([
      {
        label: "无",
        value: 0,
      },
      {
        label: "接口供应商贴扣点",
        value: 1,
      },
      {
        label: "实体供应商",
        value: 2,
      },
    ]);
    //  {"0":["40"],"1":["30"]}
    let businessTypeList = reactive({
      0: "国内",
      1: "国外",
    });
    let useList = reactive({
      0: "TMC",
      1: "分销",
      2: "电商",
    });
    let premissionList = reactive([
      "国内机票",
      "国内酒店",
      "国内保险",
      "国内租车",
    ]);
    //用户来源
    let sourceList = reactive({
      0: "PC",
      1: "H5",
      2: "APP",
    });
    let payTypeList = reactive({
      0: "线上充值",
      1: "线下充值",
    });
    let state = ref(true);
    const formState = reactive({
      username: "",
      password: "88888888",
      contactPhone: "",
      shortName: "",
      name: "",
      companyContact: "",
      supplierLevel: "",
      points: "",
      purpose: [],
      premission: [],
      payment: [],
      companyCity: [],
      userSource: "",
      remark: "",
      businessModules: {},
    });
    let validatorChecked = () => {
      if (!checked.value) {
        return Promise.reject("请选择业务类型(多选)");
      } else {
        return Promise.resolve();
      }
    };
    let validatorPre = () => {
      if (formState.premission.length == 0) {
        return Promise.reject("请勾选业务权限");
      } else {
        return Promise.resolve();
      }
    };
    let validatorPay = () => {
      if (formState.payment.length == 0) {
        return Promise.reject("请勾选付款方式");
      } else {
        return Promise.resolve();
      }
    };
    let validatorTime = () => {
      if (joinTime.value.length !== 2) {
        return Promise.reject("请填写合作期限");
      } else {
        return Promise.resolve();
      }
    };
    let validatorLevel = () => {
      if (formState.supplierLevel === "") {
        return Promise.reject("请选择会员等级");
      } else {
        return Promise.resolve();
      }
    };
    let validatorLabel = () => {
      if (labelInValue.value == "") {
        return Promise.reject("请选择供应角色");
      } else {
        return Promise.resolve("");
      }
    };
    const rules = {
      labelInValue: [
        {
          validator: validatorLabel,
          trigger: "blur",
        },
      ],
      supplierLevel: [
        {
          validator: validatorLevel,
          trigger: "blur",
        },
      ],
      joinTime: [
        {
          validator: validatorTime,
          trigger: "blur",
        },
      ],
      payment: [
        {
          validator: validatorPay,
          trigger: "change",
        },
      ],
      premission: [
        {
          validator: validatorPre,
          trigger: "change",
        },
      ],
      checked: [
        {
          validator: validatorChecked,
          trigger: "change",
        },
      ],
      name: [
        {
          required: true,
          message: "请输入供应商名称",
          trigger: "blur",
        },
      ],
      username: [
        {
          required: true,
          message: "请输入账号",
          trigger: "blur",
        },
      ],
      shortName: [
        {
          required: true,
          message: "公司简介",
          trigger: "blur",
        },
      ],
      purpose: [
        {
          type: "array",
          required: true,
          message: "请勾选用途(多选)",
          trigger: "change",
        },
      ],

      contactPhone: [
        {
          required: true,
          message: "请输入手机号码",
          trigger: "blur",
        },
      ],
      companyContact: [
        {
          required: true,
          message: "请输入联系人姓名",
          trigger: "blur",
        },
      ],
    };

    const filter = (inputValue, path) => {
      return path.some((option) => option.label.indexOf(inputValue) > -1);
    };
    //上传图片限制
    const beforeUpload = (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error("请上传图片格式");
      }
      const isLt2M = file.size / 1024 / 1024 < 0.06;
      if (!isLt2M) {
        message.error("不能超过 50kb!");
      }

      return isJpgOrPng && isLt2M;
    };

    const handleChange = (info) => {
      console.log(info);
      if (info.file.status === "uploading") {
        loading.value = true;
        return;
      }

      if (info.file.status === "done") {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, (base64Url) => {
          imageUrl.value = base64Url;
          loading.value = false;
        });
      }

      if (info.file.status === "error") {
        loading.value = false;
        message.error("upload error");
      }
    };
    let timer = ref(null);
    //验证当前用户是否存在
    let onlyUser = () => {
      if (formState.username) {
        let params = {
          username: formState.username,
        };
        supply
          .onlyUser(params)
          .then((res) => {
            if (res) {
              message.error("该用户存在");
            }
          })
          .catch((err) => message.error("该用户已经存在"));
      }
    };
    let addSupplyer = () => {
      formRef.value
        .validate()
        .then((res) => {
          formState.purpose
            ? (formState.purpose = formState.purpose.join(","))
            : "";
          // formState.companyCity
          //   ? (formState.companyCity = formState.companyCity.join(""))
          //   : "";
          let obj = {};
          formState.companyCity.forEach((item, index) => {
            obj[index] = item;
          });
          formState.companyCity = JSON.stringify(obj);
          formState.payment
            ? (formState.payment = formState.payment.join(","))
            : "";
          delete formState.premission;
          formState.state = Number(state.value);
          formState.beginTime = joinTime.value[0];
          formState.endTime = joinTime.value[1];
          formState.b2BSupplierRoleUserVos = [{ roleId: labelInValue.value }];
          formState.businessModules = JSON.stringify(formState.businessModules);
          supply
            .addSupply(formState)
            .then(() => {
              message.success("创建成功");
              router.push({
                path: "/shop/newSupplyList",
              });
            })
            .catch((err) => {
              message.error("创建失败");
            });
        })
        .catch((error) => {
          console.log("error", error);
        });
    };
    //计算业务类型和业务权限
    watch(
      () => formState.premission,
      () => {
        if (checked.value && formState.premission) {
          formState.businessModules = {};
          formState.businessModules = {
            0: [...formState.premission],
          };
          JSON.stringify(formState.businessModules);
        }
        if (checked1.value && formState.premission) {
          formState.businessModules = {};
          formState.businessModules = {
            1: [...formState.premission],
          };
        }
        if (checked1.value && checked.value && formState.premission) {
          formState.businessModules = {};
          formState.businessModules = {
            0: [...formState.premission],
            1: [...formState.premission],
          };
        }
        // if (!checked.value) {
        //   if (formState.businessModules[0]) {
        //     formState.businessModules[0] = {};
        //   }
        // }
        // if (!checked1.value) {
        //   if (formState.businessModules[1]) {
        //     formState.businessModules[1] = {};
        //   }
        // }
      }
    );
    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });

    // let supplyName = ref([]);
    // //查询供应列表
    // let searchSpuulyList = () => {
    //   let params = {
    //     offset: 0,
    //     page: 1,
    //     totalPage: 1,
    //     currentPage: pageObj.value.page,
    //     size: pageObj.value.rows,
    //   };
    //   supply.supplyList(params).then((res) => {
    //     supplyName.value = res.data.map((item) => {
    //       return item.name;
    //     });
    //   });
    // };
    // searchSpuulyList();
    let rolesList = ref([]);
    let ruleList = () => {
      menu.roleList().then((res) => {
        rolesList.value = res.data;
        // labelInValue.value = res.data[0].name;
      });
    };
    ruleList();
    onMounted(() => {
      if (route.query.id) {
        formState.companyCity = [];
        supply.getSupplyDetail(route.query.id).then((res) => {
          formState.username = res.username;
          //       password: "88888888",
          formState.contactPhone = res.contactPhone;
          formState.shortName = res.shortName;
          formState.name = res.name;
          formState.companyContact = res.companyContact;
          formState.supplierLevel = res.supplierLevel;
          formState.points = res.points;
          formState.purpose = res.purpose;
          // premission: [],
          formState.payment = formState.payment.concat(res.payment).toString();
          // let shi = res.companyCity.indexOf("市");
          // if (shi > -1) {
          //   formState.companyCity = res.companyCity
          //     .slice(0, shi + 1)
          //     .split(" ");
          // }
          // let sheng = res.companyCity.indexOf("省");
          // if (sheng > -1) {
          //   formState.companyCity = res.companyCity
          //     .slice(0, sheng + 1)
          //     .split(" ");
          // }
          let city = JSON.parse(res.companyCity);
          Object.keys(city).forEach((item, index) => {
            formState.companyCity = formState.companyCity.concat(city[item]);
          });
          formState.userSource = res.userSource;
          formState.remark = res.remark;
          let obj = JSON.parse(res.businessModules);
          for (let [key, index] in obj) {
            if (key == 0) {
              checked.value = true;
              formState.premission = obj[key];
            }
            if (key == 1) {
              checked1.value = true;
              formState.premission = obj[key];
            }
          }
        });
      }
    });
    return {
      rules,
      formRef,
      labelInValue,
      rolesList,
      ruleList,
      pageObj,
      joinTime,
      inputType,
      isEyes,
      state,
      //用户来源
      sourceList,
      //国内国外
      checked,
      checked1,
      //静态供应数据
      staticSupply,
      timer,
      onlyUser,
      addSupplyer,
      fileList1,
      fileList,
      loading,
      imageUrl,
      handleChange,
      beforeUpload,
      filter,
      cityOptions,
      formState,
      levelList,
      set,
      businessTypeList,
      useList,
      premissionList,
      payTypeList,
      labelCol: {
        span: 8,
      },
      wrapperCol: {
        span: 6,
      },
    };
  },
};
</script>
 
<style lang='scss' scoped>
.uploadStyle {
  border: 1px solid #ccc;
  padding: 10px;
  cursor: pointer;
}
</style>